'use client';
import { jsx, Fragment } from 'react/jsx-runtime';

const ClientOnly = (props) => {
  const { children, fallback } = props;
  if (typeof document === "undefined") {
    return fallback || null;
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
};

export { ClientOnly };
